import React, { useContext, useEffect, useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ClientAuthContext from "../../context/ClientAuthContext";
import { serverInstance } from "../../service/axios";

const clientPathNeedsAuth = (pathname) =>
  pathname.startsWith("/client") && pathname !== "/client/signin";

const ClientAuthProvider = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserData } = useContext(ClientAuthContext);
  const loadedTokenRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("msidclienttoken");
    if (!token) {
      loadedTokenRef.current = null;
      setUserData({});
      return;
    }

    if (loadedTokenRef.current === token) return;

    let cancelled = false;
    const clearInvalidSession = () => {
      if (localStorage.getItem("msidclienttoken") !== token) return;

      localStorage.removeItem("msidclienttoken");
      loadedTokenRef.current = null;
      setUserData({});

      if (clientPathNeedsAuth(location.pathname)) {
        navigate("/client/signin", { state: { from: location }, replace: true });
      }
    };

    serverInstance
      .post(
        "/client",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (
          cancelled ||
          localStorage.getItem("msidclienttoken") !== token
        ) {
          return;
        }

        const profile = res?.data?.data;
        if (!profile?.id) {
          clearInvalidSession();
          return;
        }

        loadedTokenRef.current = token;
        setUserData(profile);
      })
      .catch((err) => {
        if (cancelled) return;

        loadedTokenRef.current = null;
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          clearInvalidSession();
          return;
        }

        console.error(err);
      });

    return () => {
      cancelled = true;
    };
  }, [location, navigate, setUserData]);

  useEffect(() => {
    const token = localStorage.getItem("msidclienttoken");
    if (!token && clientPathNeedsAuth(location.pathname)) {
      navigate("/client/signin", { state: { from: location }, replace: true });
    }
  }, [location.pathname, navigate, location]);

  return <Outlet/>;
};

export default ClientAuthProvider;

export const useAuth = () => {
  return useContext(ClientAuthContext);
};
